import styled from "styled-components"
import { mobile, smallScreen } from "../../Responsive"

export const Container = styled.div`
    background-color: ${({ theme }) => theme.body};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

export const Title = styled.h1`
    font-size: var(--fontXL);
    margin-bottom: 20px;

    @media screen and (max-width: ${smallScreen}) {
        font-size: var(--fontL);
    }
`

export const Description = styled.div`
    font-size: var(--fontM);
    font-weight: 300;
    margin-bottom: 20px;

    @media screen and (max-width: ${smallScreen}) {
        text-align: center;
    }
`

export const InputContainer = styled.div`
    width: 50%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    border: 1px solid var(--secondary);

    ${mobile({ width: "80%" })}
`

export const Input = styled.input`
    background-color: transparent;
    color: ${({ theme }) => theme.text};
    font-size: var(--fontS);
    border: none;
    flex: 8;
    padding-left: 20px;
    transition: ease-in-out, width .35s ease-in-out;

    :focus{
        border: 2px solid var(--secondary);
        outline: none;
    }

    ::placeholder { 
        color: ${({ theme }) => theme.text};
    }
`

export const Button = styled.button`
    flex: 1;
    border: none;
    background-color: var(--secondary);
    color: var(--lightGrey);
    cursor: pointer;
`

export const Message = styled.div`
    margin-top: 20px;
    color: var(--secondary);
    font-weight: 600;
`